const { formatPercentage, formatAmount } = require('utilities/currencyHelper');
const { CURRENCIES_SYMBOLS } = require('constants/currencies');
const categoryEventList = {
    'existing': 'proc-broker-traspaso-interno-fondo-inversion',
     'new': 'proc-broker-traspaso-externo-fondo-inversion'
}
const TRANSFER_QUANTITY = "cuantia de traspaso";
const ERROR_MESSAGE_TRANSFER = "error en cuantia de traspaso";

const buildAmount = (labelEvent, amount, originFundCurrency) => {
    const value = {
        'amount': `${formatAmount(amount)}${CURRENCIES_SYMBOLS[originFundCurrency]}`,
        'participations': `${amount} participations`,
        'percentage': formatPercentage(amount)
    }

    return { amount: value[labelEvent] }
}

const buildLabelForError = () => {
    return {
        categoriaError: ERROR_MESSAGE_TRANSFER,
        descripcionError: ERROR_MESSAGE_TRANSFER,
    }
}

const brokerTransferFundsTags = (categoryEvent, labelEvent, amount = null, originFundCurrency = null, hasErrorMessage = false) => ({
    categoriaEvento: categoryEventList[categoryEvent],
    accionEvento: hasErrorMessage ? ERROR_MESSAGE_TRANSFER : TRANSFER_QUANTITY,
    etiquetaEvento: labelEvent,
    ...(amount && buildAmount(labelEvent, amount, originFundCurrency)),
    ...(hasErrorMessage && buildLabelForError())
});

module.exports = { brokerTransferFundsTags, categoryEventList, buildAmount };
